module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';
	
	fox.registerWidget('ConversationGiftsPopup', {
		configure: function () {
			this.registerOptions('', {
				useUiPosition: true,
				preventHideOnShadowClick: true,
				template: '',
				dialog: {
					'dialogClass': 'mc-site-common-popup conversation-gifts-popup',
					title: 'Select a gift',
					autoOpen: false,
					closeText: '',
					'!width': '100%',
					minHeight: 300,
					closeOnEscape: true,
					draggable: true
				},
				widgets: {
					giftBoxBody: {
						widget: 'Giftbox',
						autoRender: true,
						'embed.container': '.ui-dialog-content',
						template: 'gifts_popup_container',
						widgets: {
							tabs: {
								widget: 'Tools_TabsSwitcher',
								target: '.gift-set-list .gift-set',
								name: 'set-id',
								callback: '@parent @parent:switchSet',
								switchOnEmbed: true
							},
							summerSet: {
								widget: 'AdvancedList',
								'embed.container': '#gift-list-container',
								'tpl.row': 'gifts_popup_list_row',
								autoRender: true,
								active: false,
								collection: [{loader: true}],
								group: 'gift-sets',
								handleDom: {
									checkGift: {
										event: 'click',
										target: '.gift-item-price',
										callback: '@parent:checkGiftSingle'
									}
								}
							},
							setTitle: {
								widget: 'Widget',
								autoRender: true,
								template: 'gift_set_title',
								'embed.container': '#gift-set-title',
								'templateOptions.set': 'love'
							}
						}
					}
				},
				handleWom: {
					centerOnListAddedToDom: {
						event: 'addedToDom',
						widget: '#giftBoxBody .AdvancedList',
						callback: this.onListAddedToDom.bind(this)
					},
					giftPaySuccess: {
						event: 'giftSended',
						widget: '#giftBoxBody',
						callback: function () {
							if (this.isOpen()) {
								this.hide();
							}
						}.bind(this)
					}
				},
				handleDom: {
					closePopup: {
						event: 'click',
						target: '.close',
						callback: 'hide',
						targetWidget: '#giftBoxBody'
					}
				}
			});

			this.registerOptions('#giftBoxBody #giftboxList', {
				'tpl.row': 'gifts_popup_list_row',
				group: 'gift-sets',
				active: true,
				'wrapMethods.resetCollection': true,
				'hooks.onStartResetCollection': function (c) {
					var bodyWidget = this.rwom1('#giftBoxBody');

					if (c.length <= 12) {

						if (bodyWidget.typeAlias === 'valentines_18') {
							fox.dom.addClass('hidden', bodyWidget.dom1('.gift-set-list'));
						}

						return;
					}

					this.rwom1('#giftBoxBody #summerSet').resetCollection(c.splice(12));

					this.wait('#giftBoxBody #summerSet', 'addedToDom').then(function () {
						this.rwom1('#giftBoxBody #giftboxList').setOption('embed.location', 'inside');
					}.bind(this));

					this.switchSet('summer');

					return true;
				}.bind(this)
			});

			this.registerOptions('#giftBoxBody #cbPaymentPopup', {
				preventHideOtherPopups: true
			});

			var date = new Date();

			if (date.getMonth() === 1 && [13, 14, 15].indexOf(date.getDate()) !== -1) {
				this.registerOptions('#giftBoxBody', {
					'templateOptions.valentineDay': 1
				});
			}

			this.callParent('configure', arguments);
		},

		show: function () {
			this.callParent('show', arguments);

			var gb = this.rwom1('#giftBoxBody');

			gb.rwom1('.AdvancedList').render();

			gb.checkedGifts = [];

			this.wait('#giftBoxBody #cbPaymentPopup', 'show').then(this.hide.bind(this));

			fox.dom.addClass('blured', fox.dom.selectFirst('.wrapper'));
		},

		hide: function () {
			this.callParent('hide', arguments);

			fox.dom.removeClass('blured', fox.dom.selectFirst('.wrapper'));

			this.wom('#giftBoxBody .AdvancedList').forEach(function (w) {
				w.render();
			});
		},

		onListAddedToDom: function () {
			this._center();

			this.rwom1('#giftBoxBody').checkedGifts = [];

			$(this.dom1('.popup-content-wrapper')).mCustomScrollbar({
				autoHideScrollbar: false,
				alwaysShowScrollbar: 2,
				theme: 'light-2',
				scrollbarPosition: 'outside'
			});
		},

		switchSet: function (alias) {
			var gb = this.rwom1('.Giftbox');
			var st = this.rwom1('.Giftbox #setTitle');

			switch (alias) {
				case 'summer':
					gb.switchEmbeddedWidget('summerSet');
					st.setTemplateOptions('set', 'summer').render();
				break;
				default:
					gb.switchEmbeddedWidget('giftboxList');
					st.setTemplateOptions('set', 'love').render();
			}
		}

	}, 'Dialog');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/conversation/giftsPopup.js
// module id = 831
// module chunks = 4